import SERVICES from 'app-constants/service.names';
import { appConfig } from 'config';
import { get, size } from 'lodash';
import axios from 'axios';
import { idb } from 'utils';
import { CollectionService } from './base.service';

class Service extends CollectionService {
  constructor() {
    super(SERVICES.COMMON);
  }

  getAppConfig = (query?: any) =>
    this.client.get(SERVICES.APP_CONFIG, { params: query });

  getCommonReport = (data: any, headers?: any) =>
    this.client.post(`${SERVICES.COMMON}/graph-query`, data, headers);

  postPrintBill = (data: any) =>
    this.client.post(`${appConfig.print_url}/api/print/vtp`, data);
  buildReport = (data: any) =>
    axios.post(`${appConfig.report_url}/api/report`, data, {
      responseType: 'blob',
      headers: { Authorization: 'Basic '.concat(appConfig.report_auth) },
    });

  fetchDetailProvince = async (province_id): Promise<any> => {
    let [districts, wards] = await idb.getDetailProvince(province_id);
    if (!size(districts) || !size(wards)) {
      const response = await this.getAppConfig({
        p_type: 'DISTRICT',
        province_id,
      });
      const data = get(response, 'data.data', {});
      districts = get(data, 'districts', []);
      wards = get(data, 'wards', []);
    }
    return { districts, wards };
  };
  fetchDistrictsWards = async (): Promise<any> => {
    const response = await this.getAppConfig({
      p_type: 'DISTRICTS_WARDS',
    });
    const data = get(response, 'data.data', {});
    const districts = get(data, 'districts', []);
    const wards = get(data, 'wards', []);
    return { districts, wards };
  };
  commonMutations = (payload) =>
    this.client.post('/v2/entry-common-mutations', payload);
  commonBatchQuery = (payload) =>
    this.client.post('/v2/entry-common-queries', payload);
}

export default new Service();
